export const enum componentStatus {
    LOADING,
    READY,
    STARTED,
    RUNNING,
    PAUSED,
    SUCCEEDED,
    FAILED,
    COMPLETED
}

export const enum componentName {
    WEBARGO,
    VIDEO,
    TRACKING,
    SCENE,
    RECO,
    ODO
}

export enum afterRecoStrategy {
    TRACK, //we track
    GYRO, //we use gyro only
    FTS //FTS only
}

export enum afterTrackingLostStrategy {
    FTS,
    FADE
}

export enum cameraDisplayMode {
    NONE,
    AR,
    FTS, //fly to screen
    G //gyro
}

export const enum trackingStatus {
    IDLE,
    TRACKING,
    LOST
}

export abstract class Argocomponent {
    public name: componentName;
    protected status: componentStatus;

    public checkCompatibility(): boolean {
        return true;
    }

    public getStatus(): componentStatus {
        return this.status;
    }

    /**
     * returns a json containing info about the state of the component
     */
    abstract getState();

    public canStart(): boolean {
        return true;
    }
    abstract start(): void;

    abstract pause(): void;

    abstract stop(): void;

    /**
     * called at every frame
     */
    abstract render(): void;

    /**
     * called to change the status of a component. Do not change the status directly !
     */
    protected newStatus(status: componentStatus): void {
        if (status == this.status) {
            return;
        }
        this.status = status;
    }
}
